import type { ReactNode } from 'react';

/** Required legal or rule text: one short line, full text under «جزئیات» (XAP-27, D-76). */
export function OnDemandCopy({
  details,
  label = 'جزئیات',
  short,
}: {
  readonly details: ReactNode;
  readonly label?: string;
  readonly short: string;
}) {
  return (
    <span className="admin-on-demand-copy">
      {short}{' '}
      <details>
        <summary>{label}</summary>
        <div className="admin-on-demand-copy__body">{details}</div>
      </details>
    </span>
  );
}
